<ng-container *ngIf="product">
  <div class="product-detail__header">Loja - Detalhes do Produto</div>
  <div class="product-detail__content">
    <div class="product-detail__content__card">
      <div class="card card-user">
        <div class="image"></div>
        <div class="card-body">
          <div class="user">
            <img
              class="avatar"
              *ngIf="product.images?.length"
              [src]="product.images[0]"
            />
            <img
              class="avatar"
              src="assets/images/no_img_available.jpg"
              *ngIf="!product.images?.length"
            />
            <h4>{{ product.name }}</h4>
            <span class="rating">
              <p-rating
                [formControl]="rating"
                [stars]="5"
                [readonly]="true"
                [cancel]="false"
              >
                <ng-template pTemplate="onicon">
                  <i class="pi pi-star-fill"></i>
                </ng-template>
                <ng-template pTemplate="officon">
                  <i class="pi pi-star"></i>
                </ng-template>
              </p-rating>
              &nbsp;
              {{ rating.value }}
            </span>
            <span *ngIf="reviewsCount && reviewsCount > 1">
              {{ reviewsCount | number: '1.0-0' }} avaliações
            </span>
            <span *ngIf="reviewsCount && reviewsCount === 1">
              1 avaliação
            </span>
            <span *ngIf="!reviewsCount">Sem avaliações</span>
            <p *ngIf="product.brand"><b>Marca</b>: {{ product.brand }}</p>
            <p *ngIf="brandCategory?.brandEquity">
              <b>Valor da marca</b>:
              {{ getBrandEquityLabel(brandCategory.brandEquity) }}
            </p>
            <p *ngIf="product.EAN"><b>EAN</b>: {{ product.EAN }}</p>
            <p *ngIf="product.sku"><b>SKU</b>: {{ product.sku }}</p>
            <p *ngIf="product.costPrice">
              <b>Preço custo</b>: {{ product.costPrice | currency: 'BRL' }}
            </p>
            <p *ngIf="productVariants?.length">
              <b>Preço custo médio (variantes)</b>:
              {{ avgVariantsCostPrice | currency: 'BRL' }}
            </p>
            <ng-container *ngIf="precificaMinPrice">
              <p *ngIf="precificaMinPrice.emptyLabel">
                <b>Menor preço Precifica</b>:
                {{ precificaMinPrice.emptyLabel }}
              </p>
              <ng-container *ngIf="precificaMinPrice.status === 'available'">
                <p>
                  <b>Menor preço Precifica</b>:
                  {{ precificaMinPrice.price | currency: 'BRL' }}
                </p>
                <p *ngIf="precificaMinPrice.competitorId">
                  <b>Concorrente</b>: {{ precificaMinPrice.competitorId }}
                </p>
                <p *ngIf="precificaMinPrice.capturedAt">
                  <b>Capturado em</b>:
                  {{ precificaMinPrice.capturedAt | date: 'dd/MM/yyyy' }}
                </p>
                <p *ngIf="precificaMinPrice.differencePercent !== null">
                  <b>Diferença vs. preço clube</b>:
                  {{ precificaMinPrice.differencePercent | number: '1.1-1' }}%
                </p>
              </ng-container>
            </ng-container>
            <p>
              <b>Estoque</b>:
              {{ product.stock?.quantity || 0 | number: '1.0-0' }}
            </p>
            <p>
              <b>Categoria</b>: <span [innerHTML]="categoryTreeLabel"></span>
            </p>
            <p *ngIf="subscriptionProduct?.productId" class="with-button">
              <span>
                <b>Disponível Assinatura</b>:
                <a
                  [routerLink]="
                    '/products/catalog/product/' + subscriptionProduct.productId
                  "
                  class="data-link"
                >
                  {{ subscriptionProduct.productName | titlecase }}
                </a>
              </span>
              <p-button
                icon="pi pi-sync"
                styleClass="p-button-primary p-button-xs"
                [text]="true"
                [rounded]="true"
                [pTooltip]="'Sincronizar campos divergentes: ' + toSyncString"
                (onClick)="syncInfo()"
                *ngIf="permission && toSync?.length"
              />
            </p>
            <div *ngIf="hasProductErrors" class="product-errors-alert">
              <p-message severity="warn" [closable]="false">
                <div class="product-errors-content">
                  <strong>Produto com Erros!</strong>
                  <ul>
                    <li *ngFor="let error of productErrorsList">
                      {{ error }}
                    </li>
                  </ul>
                  <a [routerLink]="['/shop-products/product-errors']">
                    Ver todos os produtos com erros
                  </a>
                </div>
              </p-message>
            </div>
            <div
              *ngIf="hasVariantErrors"
              class="product-errors-alert variant-errors-alert"
            >
              <p-message severity="warn" [closable]="false">
                <div class="product-errors-content">
                  <strong>Variantes com Erros!</strong>
                  <div
                    *ngFor="let variantWithError of variantsWithErrors"
                    class="variant-error"
                  >
                    <h5>{{ getVariantLabel(variantWithError.variant) }}</h5>
                    <ul>
                      <li *ngFor="let error of variantWithError.errors">
                        {{ error.error }}
                      </li>
                    </ul>
                  </div>
                  <a [routerLink]="['/shop-products/product-errors']">
                    Ver todos os produtos com erros
                  </a>
                </div>
              </p-message>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="product-detail__content__tabs">
      <div class="card">
        <p-tabView
          [activeIndex]="selectedTab"
          (activeIndexChange)="tabChanged($event)"
        >
          <p-tabPanel header="Informações">
            <app-shop-product-form
              [permission]="permission"
              [product]="product"
              [categories]="categories"
              *ngIf="categories"
              (productUpdated)="findProduct()"
            />
          </p-tabPanel>
          <p-tabPanel header="Descrições">
            <app-shop-product-description-form
              [permission]="permission"
              [product]="product"
              (productUpdated)="findProduct()"
              [subscriptionProduct]="subscriptionProduct"
            />
          </p-tabPanel>
          <p-tabPanel
            [header]="
              'Variantes (' +
              (productVariants?.length || 0 | number: '1.0-0') +
              ')'
            "
            *ngIf="product.hasVariants"
          >
            <app-table
              *ngIf="variantCols && productVariants && !productVariant"
              [cols]="variantCols"
              [lazy]="false"
              [elements]="productVariants"
              modelName="variantes"
              [showTitle]="false"
              sortField="grade.value"
              [addButton]="false"
              [sortOrder]="-1"
              [changeColumns]="false"
              [defaultRows]="15"
              linkTarget="_action"
              [actionFields]="['grade.title', 'grade.value', 'EAN', 'sku']"
              (linkAction)="productVariant = $event.value"
            />
            <div
              *ngIf="
                variantCols &&
                productVariants &&
                !productVariant &&
                hasVariantErrors
              "
              class="variant-errors-panel"
            >
              <h4>Variantes com Erros:</h4>
              <p-accordion>
                <p-accordionTab
                  *ngFor="let variantWithError of variantsWithErrors"
                  [header]="getVariantLabel(variantWithError.variant)"
                >
                  <ul class="variant-errors-list">
                    <li *ngFor="let error of variantWithError.errors">
                      {{ error.error }}
                    </li>
                  </ul>
                  <p-button
                    label="Editar Variante"
                    icon="pi pi-pencil"
                    styleClass="p-button-sm"
                    (onClick)="productVariant = variantWithError.variant"
                  >
                  </p-button>
                </p-accordionTab>
              </p-accordion>
            </div>
            <ng-container *ngIf="productVariant">
              <p-button
                [text]="true"
                [rounded]="true"
                pRipple
                label="Voltar"
                icon="pi pi-arrow-left"
                (onClick)="backFromVariantForm()"
              ></p-button>
              <app-shop-product-variant-form
                [variant]="productVariant"
                [permission]="permission"
              />
            </ng-container>
          </p-tabPanel>
          <p-tabPanel header="Prova virtual">
            <app-shop-product-try-on-form
              *ngIf="isTryOnTabActive"
              [productId]="productId"
              [hasVariants]="!!product.hasVariants"
              [permission]="permission"
              (saved)="findProduct()"
            />
          </p-tabPanel>
          <p-tabPanel header="Imagens">
            <ng-container *ngIf="product.images?.length; else noImageTemplate">
              <app-drag-drop-list
                [list]="product.images"
                [template]="imageTemplate"
                [permission]="false"
              >
                <ng-template #imageTemplate let-image="data">
                  <p-button
                    [rounded]="true"
                    severity="danger"
                    [text]="true"
                    icon="pi pi-trash"
                    pTooltip="Excluir imagem"
                    tooltipPosition="bottom"
                    type="button"
                    (onClick)="confirmDeleteImage(image, $event)"
                    *ngIf="permission"
                  />
                  <img style="width: 100%" [src]="image" alt="" />
                </ng-template>
              </app-drag-drop-list>
            </ng-container>

            <ng-template #noImageTemplate>
              <span>Nenhuma imagem adicionada ao produto</span>
              <p>
                É obrigatório cadastrar ao menos uma imagem para publicar o
                produto.
              </p>
            </ng-template>
          </p-tabPanel>
        </p-tabView>
      </div>
    </div>
  </div>
</ng-container>
<p-confirmPopup styleClass="danger" />
<p-toast />
